import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Result, Button } from 'antd';
import LoginScreenUrl from '@images/login-screen.svg?url';
import { Background, Overlay } from '@src/BaseApp/auth/Login.styles';
import styles from './index.less';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.pageNotFound}>
      <Background id="login-bg-image-id" $bg={LoginScreenUrl} />
      <Overlay />
      <Result
        status="404"
        title={<span className={styles.errorCode}>404</span>}
        subTitle="Sorry, the page you are looking for doesn't exist."
        extra={
          <Button type="primary" size="large" onClick={() => navigate('/login')}>
            Go Home
          </Button>
        }
      />
    </div>
  );
};

PageNotFound.defaultProps = {
  className: '',
  title: 'Oops!',
  description: 'This page is not available!',
};

export default PageNotFound;
